/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @typedef {object} actionState
 * @property {integer} [height] - The height of the placement of the toolbar, it is just a hint.
 * @property {integer} [width] - The width of the placement of the toolbar, it is just a hint.
 */

/**
 * @typedef {object} sortActionState
 * @property {integer} [height] - The height of the placement of the toolbar, it is just a hint.
 * @property {integer} [width] - The width of the placement of the toolbar, it is just a hint.
 * @property {string} [currentSelectedItem] - the current sort for dataItem
 * @property {object} [possibleSorts] - possible sorts
 */

/**
  * @typedef {object} formatActionState
  * @property {integer} [height] - The height of the placement of the toolbar, it is just a hint.
  * @property {integer} [width] - The width of the placement of the toolbar, it is just a hint.
  * @property {string} [itemLabel] - the label of current item
  * @property {string} [autoDescription] - auto format description
  * @property {string} [defaultDescription] - default format description
  */

/**
 * @typedef {object} possibleSorts
 * @property {string} [id] - The id of sort like 'asc', 'desc',...
 * @property {string} [localizedString] - The localized string value of sort
 */